import { GraphApiMethod, GraphApiResponse } from '@/api/core';
import { HandleErrorInput, handleError } from '@/utils/custom';
import createGraphApiHook, { CreateGraphApiHookHook } from '@/hooks/createGraphApiHook';

import { DeleteCombineRuleBulkDocument } from '@/api/queries';
import { DeleteCombineRuleInput } from '@/models/gen/graphql';
import graphApi from '@/api';

// Global Service Variables
const onError = (res: HandleErrorInput): void => handleError(res, { notification: { title: 'Delete Combine Rule Setting' } });

// Service Function Signature
type ServiceMethodPayload = string[];
interface ServiceMethod {
  (payload: ServiceMethodPayload): Promise<GraphApiResponse>;
}

// DeleteCombineRuleBulk Service
export const { deleteCombineRuleBulk, useDeleteCombineRuleBulk } = ((): {
  deleteCombineRuleBulk: ServiceMethod;
  useDeleteCombineRuleBulk: CreateGraphApiHookHook<ServiceMethod>;
} => {
  const [mutate] = graphApi(DeleteCombineRuleBulkDocument, {
    onError,
  }).map(
    (fn: GraphApiMethod<typeof DeleteCombineRuleBulkDocument>): ServiceMethod =>
      async (ids: ServiceMethodPayload): Promise<GraphApiResponse> => {
        const search: DeleteCombineRuleInput[] = ids.map((id: string): DeleteCombineRuleInput => ({ id }));
        const res = await fn({ input: { search } });
        return res;
      }
  );

  const useService = createGraphApiHook(mutate, { bubble: true });
  return {
    deleteCombineRuleBulk: mutate,
    useDeleteCombineRuleBulk: useService,
  };
})();
